import { render, staticRenderFns } from "./OrganizationIntroduction.vue?vue&type=template&id=4ff49b87&"
import script from "./OrganizationIntroduction.vue?vue&type=script&lang=js&"
export * from "./OrganizationIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationIntroduction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports